import script from "./pdfform.vue?vue&type=script&setup=true&lang=js"
export * from "./pdfform.vue?vue&type=script&setup=true&lang=js"

import "./pdfform.vue?vue&type=style&index=0&id=07e5a358&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e5a358"]])

export default __exports__